import { bootstrapApplication } from '@angular/platform-browser'
import { registerLocaleData } from '@angular/common'
import localeDe from '@angular/common/locales/de'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { environment } from './environments/environment'

registerLocaleData(localeDe)

function injectGtmScripts() {
  // Google Tag Manager (head script)
  const script = document.createElement('script')
  script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NR5LZM5');`
  document.head.appendChild(script)

  // Google Tag Manager (noscript)
  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-NR5LZM5'
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)
}

if (environment.production) {
  injectGtmScripts()

  const methods: (keyof Console)[] = ['log', 'debug', 'info', 'warn']
  /* eslint-disable @typescript-eslint/no-explicit-any */
  /* eslint-disable @typescript-eslint/no-empty-function */
  methods.forEach((method) => {
    ;(console as any)[method] = () => {}
  })
  /* eslint-enable @typescript-eslint/no-empty-function */
  /* eslint-enable @typescript-eslint/no-explicit-any */
}

// The [disabled] attribute is intentionally combined with reactive forms here (see contact.component),
// so Angular's "disabled attribute with a reactive form directive" dev-mode warning is expected and safe to ignore.
const originalWarn = console.warn.bind(console)
console.warn = (...args: unknown[]) => {
  const firstArg = args[0]
  if (typeof firstArg === 'string' && firstArg.includes('disabled attribute with a reactive form directive')) {
    return
  }
  originalWarn(...args)
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
